import { render, staticRenderFns } from "./StatusOrderComponent.vue?vue&type=template&id=01b98796"
import script from "./StatusOrderComponent.vue?vue&type=script&lang=js"
export * from "./StatusOrderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports